module.exports = __webpack_public_path__ + "static/media/logo-maven.aa98e784.png";